import { Flex, Text } from '@chakra-ui/react';
import MultiRangeSlider from 'multi-range-slider-react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Slider.css';

import { getMaxSliderValue, getMinSliderValue, handleMinMaxSliderValue } from 'redux/PlanPageSlice';
import { getPlanPageThemeColors } from 'redux/ThemeSlice';
import { AppDispatch } from 'utils/GlobalHelpers';
import { usePlanPageRevampVariant } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/usePlanPageUiRevamp';

export interface Properties {
  labels: string[];
  variant?: 'legacy' | 'revamp';
}

const CustomRangeSlider = ({ labels, variant = 'legacy' }: Properties) => {
  const isRevamp = usePlanPageRevampVariant(variant);
  const minValue = useSelector(getMinSliderValue);
  const maxValue = useSelector(getMaxSliderValue);
  const themeColors = useSelector(getPlanPageThemeColors);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(100);

  const dispatch: AppDispatch = useDispatch();
  const handleInput = (event: any) => {
    if (event.minValue !== minValue || event.minValue !== maxValue) {
      dispatch(handleMinMaxSliderValue({ min: event.minValue, max: event.maxValue }));
    }
  };

  return (
    <>
      <MultiRangeSlider
        style={{
          paddingBottom: '5px',
          outline: 'none',
          boxShadow: 'none',
          border: 'none',
          color: 'black',
          fontSize: '12px',
          whiteSpace: 'nowrap',
          paddingTop: '12px',
        }}
        className={isRevamp ? 'multi-range-slider plan-chart-slider-revamp' : 'multi-range-slider'}
        labels={labels}
        min={0}
        max={labels.length - 1}
        step={1}
        ruler={false}
        stepOnly={false}
        label={false}
        minCaption={labels[min]}
        maxCaption={labels[max]}
        minValue={minValue}
        maxValue={labels.length < maxValue ? labels.length - 1 : maxValue}
        onChange={(event: any) => {
          if (event) handleInput(event);
        }}
        onInput={(event: any) => {
          if (event) {
            setMin(event.minValue);
            setMax(event.maxValue);
          }
        }}
        barLeftColor={'#transparent'}
        barRightColor={'transparent'}
        barInnerColor={'#dedcdc00'}
        thumbLeftColor={'white'}
        thumbRightColor={'white'}
      />
      <Flex justifyContent='space-between'>
        <Text color={isRevamp ? themeColors.textSecondary : 'black'} fontSize='10px'>
          {labels[minValue]}
        </Text>
        <Text color={isRevamp ? themeColors.textSecondary : 'black'} fontSize='10px'>
          {labels[maxValue]}
        </Text>
      </Flex>
    </>
  );
};

export default CustomRangeSlider;
